module.exports = {"data":{"contributionsJson":{"name":"buddha's tea","www_url":"http://www.i-love-u.ch","thema":"tea","issue_month":"July","issue_year":2007,"issue_date":200707,"artist":"luzora","location":"Schweiz","email":"luzora@hotmail.com","id":"contribution_295","media_type":"textz","position_in_section":1,"media_uri":"media/2007/July/textz/tea.jpg","media_th_uri":"media/2007/July/textz/tn_tea.jpg","still_image_count":1,"moving_image_count":1,"textz_count":1,"soundz_count":0}},"pathContext":{"id":"contribution_295"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/issue-200707-textz-1.json
// module id = 946
// module chunks = 230830472289591